/**
 * Set when the retailer dismisses the Last Chance First Order Incentive modal
 */ export var LAST_CHANCE_FIRST_ORDER_INCENTIVE_MODAL_DISMISS = 'LAST_CHANCE_FIRST_ORDER_INCENTIVE_MODAL_DISMISS';
